module.exports = __webpack_public_path__ + "img/before7.87c415ea.png";